import PropTypes from 'prop-types'


const Image = data => (data && data.fluid ? data.fluid : undefined)

Image.propTypes = PropTypes.shape({
  src: PropTypes.string,
  srcSet: PropTypes.string,
})

Image.defaultProps = {
  src: '',
  srcSet: '',
}

export default Image
